var pug = require("!../../../../../../node_modules/pug-runtime/index.js");

function template(locals) {var pug_html = "", pug_mixins = {}, pug_interp;;var locals_for_with = (locals || {});(function (ngRequired, required) {pug_mixins["centered-content"] = pug_interp = function(){
var block = (this && this.block), attributes = (this && this.attributes) || {};
pug_html = pug_html + "\u003Cdiv" + (pug.attrs(pug.merge([{"class": "centered-content","layout": "row"},attributes]), true)) + "\u003E\u003Cdiv class=\"content\" layout=\"column\" layout-align=\"start stretch\" flex flex-md=\"90\" flex-lg=\"80\" flex-gt-lg=\"70\" flex-offset-md=\"5\" flex-offset-lg=\"10\" flex-offset-gt-lg=\"15\"\u003E";
block && block();
pug_html = pug_html + "\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E";
};
pug_mixins["contentful-component"] = pug_interp = function(component){
var block = (this && this.block), attributes = (this && this.attributes) || {};
pug_html = pug_html + "\u003Cdiv" + (pug.attr("ng-if", "" + component + ".fields.type === 'wide'", true, true)) + "\u003E\u003Cicon-panel" + (" class=\"wide-panel\""+pug.attr("panel", "" + component, true, true)) + "\u003E\u003C\u002Ficon-panel\u003E\u003C\u002Fdiv\u003E";
pug_mixins["centered-content"].call({
block: function(){
pug_html = pug_html + "\u003Cicon-panel" + (" class=\"standard-panel\""+pug.attr("panel", "" + component, true, true)) + "\u003E\u003C\u002Ficon-panel\u003E";
},
attributes: {"ng-if": pug.escape("" + component + ".fields.type !== 'wide'")}
});
};





























pug_mixins["required-radio-container"] = pug_interp = function(name, model, layout){
var block = (this && this.block), attributes = (this && this.attributes) || {};
ngRequired = attributes['ng-required']
required = !ngRequired
layout = layout || 'row'
pug_html = pug_html + "\u003Cmd-radio-group" + (pug.attr("ng-required", ngRequired, true, true)+pug.attr("ng-model", model, true, true)+pug.attr("layout", layout, true, true)+pug.attr("ng-class", "'" + name + "'", true, true)) + "\u003E";
block && block();
pug_html = pug_html + "\u003Chelp-mate" + (pug.attr("topic", name, true, true)) + "\u003E\u003C\u002Fhelp-mate\u003E\u003C\u002Fmd-radio-group\u003E\u003Cinput-container class=\"hidden-input\"\u003E\u003Cinput" + (pug.attr("ng-required", ngRequired, true, true)+pug.attr("required", required, true, true)+pug.attr("name", name, true, true)+pug.attr("ng-model", model, true, true)+" ng-show=\"false\" aria-label=\"require\"") + "\u003E\u003C\u002Finput-container\u003E";
};








pug_mixins["required-select"] = pug_interp = function(name, model, label){
var block = (this && this.block), attributes = (this && this.attributes) || {};
label = label || name
pug_html = pug_html + "\u003Cinput-container" + (pug.attr("label", label, true, true)) + "\u003E\u003Cmd-select" + (" class=\"required-select big-list\""+pug.attr("ng-model", model, true, true)+pug.attr("ng-class", "'" + name + "'", true, true)+pug.attr("placeholder", label, true, true)+pug.attr("aria-label", label, true, true)) + "\u003E";
block && block();
pug_html = pug_html + "\u003C\u002Fmd-select\u003E\u003Cinput-container class=\"hidden-input\"\u003E\u003Cinput" + (pug.attr("required", true, true, true)+pug.attr("name", name, true, true)+pug.attr("ng-model", model, true, true)+" ng-show=\"false\" aria-label=\"require\"") + "\u003E\u003C\u002Finput-container\u003E\u003C\u002Finput-container\u003E";
};










































































pug_mixins["rateDisplay"] = pug_interp = function(rate){
var block = (this && this.block), attributes = (this && this.attributes) || {};
pug_html = pug_html + (pug.escape(null == (pug_interp = rate) ? "" : pug_interp)) + "\u003Cimg src=\"\u002Ficons\u002Ficon-percent-pa.svg\" alt=\"percentage pa\"\u003E";
};












pug_html = pug_html + "\u003Cmd-dialog class=\"confirm-bank-details\"\u003E\u003Cmd-dialog-content\u003E\u003Ch2\u003EVerify bank account number\u003C\u002Fh2\u003E\u003Cdiv class=\"pairs\"\u003E\u003Cdiv class=\"pair\"\u003E\u003Clabel\u003EAccount name\u003C\u002Flabel\u003E\u003Cspan class=\"value investor-name\"\u003E{{vm.investor.name}}\u003C\u002Fspan\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"pair\"\u003E\u003Clabel\u003EBSB\u003C\u002Flabel\u003E\u003Cspan class=\"value bank-details-bsb\"\u003E{{vm.bankDetails.bsb}}\u003C\u002Fspan\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"pair\"\u003E\u003Clabel\u003EAccount number\u003C\u002Flabel\u003E\u003Cspan class=\"value bank-details-acc\"\u003E{{vm.bankDetails.accountNumber}}\u003C\u002Fspan\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"mfa\"\u003E\u003Ch3\u003ETwo-factor authentication\u003C\u002Fh3\u003E\u003Cp\u003ETo verify your bank account number you will need to enter an SMS verification code.\u003C\u002Fp\u003E\u003Cmd-button class=\"md-raised md-primary send-code\" ng-click=\"vm.sendChallengeCode()\"\u003ESend Verification Code\u003C\u002Fmd-button\u003E\u003Cp class=\"sentResponse\" data-ng-if=\"vm.challengeCodeSent()\"\u003EThe verification code has been sent to the mobile number ending in \u003Ci\u003E{{vm.phone | asMaskedNumeric}}\u003C\u002Fi\u003E\u003C\u002Fp\u003E\u003Cp class=\"error\" data-ng-if=\"vm.hasChallengeCodeError()\"\u003EProblem: {{vm.errorMessage}}\u003C\u002Fp\u003E\u003Cdiv class=\"challenge-code\"\u003E\u003Cinput-container label=\"Enter the verification code\"\u003E\u003Cinput required name=\"challengeCode\" data-ng-model=\"vm.challengeCode\" pattern=\"^\\s*\\d{6}\\d*\\s*$\"\u003E\u003Cng-message when=\"pattern\"\u003EMust be at least six digits\u003C\u002Fng-message\u003E\u003C\u002Finput-container\u003E\u003C\u002Fdiv\u003E\u003Cmd-progress-circular ng-if=\"vm.awaitingResponse()\" md-mode=\"indeterminate\" md-diameter=\"32\"\u003E\u003C\u002Fmd-progress-circular\u003E\u003C\u002Fdiv\u003E\u003C\u002Fmd-dialog-content\u003E\u003Cmd-dialog-actions\u003E\u003Cmd-button class=\"md-raised md-secondary\" ng-click=\"vm.closeAction()\"\u003ECancel\u003C\u002Fmd-button\u003E\u003Cmd-button class=\"md-raised md-primary\" ng-click=\"vm.saveAction()\" ng-disabled=\"vm.disableSave()\"\u003ESave\u003C\u002Fmd-button\u003E\u003C\u002Fmd-dialog-actions\u003E\u003C\u002Fmd-dialog\u003E";}.call(this,"ngRequired" in locals_for_with?locals_for_with.ngRequired:typeof ngRequired!=="undefined"?ngRequired:undefined,"required" in locals_for_with?locals_for_with.required:typeof required!=="undefined"?required:undefined));;return pug_html;};
module.exports = template;